var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTemplateGallery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.132 18.52C20.2195 18.3671 20.3459 18.24 20.4983 18.1516C20.6508 18.0632 20.8238 18.0166 21 18.0166C21.1763 18.0166 21.3493 18.0632 21.5018 18.1516C21.6542 18.24 21.7805 18.3671 21.868 18.52L24.145 22.501C24.2329 22.6532 24.2791 22.8258 24.279 23.0015C24.2789 23.1772 24.2326 23.3498 24.1446 23.5019C24.0566 23.654 23.93 23.7802 23.7777 23.8678C23.6254 23.9554 23.4527 24.0014 23.277 24.001H18.723C18.5473 24.0014 18.3746 23.9554 18.2224 23.8678C18.0701 23.7802 17.9435 23.654 17.8555 23.5019C17.7675 23.3498 17.7212 23.1772 17.7211 23.0015C17.721 22.8258 17.7672 22.6532 17.855 22.501L20.132 18.52Z",
    stroke: "currentColor",
    strokeOpacity: 0.7,
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 14.001C22.6569 14.001 24 12.6578 24 11.001C24 9.34412 22.6569 8.00098 21 8.00098C19.3431 8.00098 18 9.34412 18 11.001C18 12.6578 19.3431 14.001 21 14.001Z",
    stroke: "currentColor",
    strokeWidth: 1.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 18.001H9C8.44772 18.001 8 18.4487 8 19.001V23.001C8 23.5533 8.44772 24.001 9 24.001H13C13.5523 24.001 14 23.5533 14 23.001V19.001C14 18.4487 13.5523 18.001 13 18.001Z",
    stroke: "currentColor",
    strokeWidth: 1.75
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 8C11.75 7.58579 11.4142 7.25 11 7.25C10.5858 7.25 10.25 7.58579 10.25 8H11.75ZM10.25 9.5V10.25H11.75V9.5H10.25ZM10.25 8V9.5H11.75V8H10.25Z",
    fill: "currentColor",
    fillOpacity: 0.7
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 12.5V11.75H10.25V12.5H11.75ZM10.25 14C10.25 14.4142 10.5858 14.75 11 14.75C11.4142 14.75 11.75 14.4142 11.75 14H10.25ZM10.25 12.5V14H11.75V12.5H10.25Z",
    fill: "currentColor",
    fillOpacity: 0.7
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14 11L8 11",
    stroke: "currentColor",
    strokeOpacity: 0.7,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplateGallery);
export default __webpack_public_path__ + "static/media/template-gallery.dae14528accd74744aaafd0197965427.svg";
export { ForwardRef as ReactComponent };